import React from 'react';
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
        <div className="footer__container container">
            <h1 className="footer__title">Suhaib</h1>

            <ul className="footer__list">
                <li>
                    <a href="#about" className="footer__link">
                        About
                    </a>
                </li>
                <li>
                    <a href="#skills" className="footer__link">
                        Skills
                    </a>
                </li>
                <li>
                    <a href="#portfolio" className="footer__link">
                        Projects
                    </a>
                </li>
            </ul>

            <div className="footer__social">
                <a href="https://github.com/suhaib-md" className="footer__social-link" target="_blank" rel="noreferrer">
                    <i className="uil uil-github-alt"></i>
                </a>
                <a href="https://www.linkedin.com/in/muhammedsuhaibv/" className="footer__social-link" target="_blank" rel="noreferrer">
                    <i className="uil uil-linkedin-alt"></i>
                </a>
                <a href="https://www.instagram.com/vmdsuhaib/" className="footer__social-link" target="_blank" rel="noreferrer">
                    <i className="uil uil-instagram"></i>
                </a>
                <a href="https://twitter.com/Suhaibvms" className="footer__social-link" target="_blank" rel="noreferrer">
                    <i className="uil uil-twitter-alt"></i>
                </a>                
            </div>

            <span className="footer__copy">&#169;2024 Muhammed Suhaib. All rights reserved</span>
        </div>
    </footer>
  )
}

export default Footer